import * as Types from '@seeqdev/api/graphql/types';

export type GqlWorkbookCoreFragment = { __typename?: 'WorkbookGraphQL', id: string, name: string, description: string | undefined, type: string, createdAt: string, updatedAt: string, isArchived: boolean, parentFolderId: string | undefined, isLocked: boolean, lockedMetadata: string | undefined, workbookState: string | undefined, evidenceTableDefinitionId: string | undefined, serverErrors: Array<{ __typename?: 'ServerError', field: string, message: string, path: Array<string> }>, effectivePermissions: { __typename?: 'PermissionsGraphQL', read: boolean, write: boolean, manage: boolean }, owner: { __typename?: 'IdentityPreviewGraphQL', id: string | undefined, name: string | undefined, email: string | undefined, username: string | undefined, type: string | undefined } | undefined, ancestors: Array<{ __typename?: 'ItemPreviewGraphQL', id: string | undefined, name: string | undefined, type: string | undefined, translationKey: string | undefined }>, worksheets?: Array<{ __typename?: 'WorksheetGraphQL', id: string, name: string, createdAt: string, updatedAt: string, isArchived: boolean, isDashboard: boolean, duplicationErrorDocument: string | undefined, report: { __typename?: 'ItemPreviewGraphQL', id: string | undefined, name: string | undefined, type: string | undefined } | undefined, currentWorkstep: { __typename?: 'WorkstepGraphQL', id: string } | undefined }>, selectedWorksheet: { __typename?: 'WorksheetGraphQL', id: string, name: string, isDashboard: boolean, isArchived: boolean, createdAt: string, updatedAt: string, duplicationErrorDocument: string | undefined, serverErrors: Array<{ __typename?: 'ServerError', field: string, message: string, path: Array<string> }>, report: { __typename?: 'ItemPreviewGraphQL', id: string | undefined, name: string | undefined, type: string | undefined } | undefined, currentWorkstep: { __typename?: 'WorkstepGraphQL', id: string, name: string, type: string, createdAt: string, data: string, previous: string | undefined, next: string | undefined, last: string | undefined } | undefined, requestedWorkstep: { __typename?: 'WorkstepGraphQL', id: string, name: string, type: string, createdAt: string, data: string, previous: string | undefined, next: string | undefined, last: string | undefined } | undefined } | undefined };


export const WorkbookCoreFragmentDoc = `
    fragment WorkbookCore on WorkbookGraphQL {
  serverErrors {
    field
    message
    path
  }
  id
  name
  description
  type
  createdAt
  updatedAt
  isArchived
  effectivePermissions {
    read
    write
    manage
  }
  owner {
    id
    name
    email
    username
    type
  }
  parentFolderId
  ancestors {
    id
    name
    type
    translationKey
  }
  isLocked
  lockedMetadata
  workbookState
  evidenceTableDefinitionId
  worksheets @skip(if: $skipWorksheets) {
    id
    name
    createdAt
    updatedAt
    isArchived
    isDashboard
    duplicationErrorDocument
    report {
      id
      name
      type
    }
    currentWorkstep {
      id
    }
  }
  selectedWorksheet: worksheet(id: $worksheetId) {
    id
    name
    serverErrors {
      field
      message
      path
    }
    isDashboard
    isArchived
    createdAt
    updatedAt
    duplicationErrorDocument
    report {
      id
      name
      type
    }
    currentWorkstep {
      id
      name
      type
      createdAt
      data
      previous
      next
      last
    }
    requestedWorkstep: workstep(id: $workstepId) {
      id
      name
      type
      createdAt
      data
      previous
      next
      last
    }
  }
}
    `;